import styled, {ThemeProps} from 'styled-components';

import {Theme} from '@ibibo/build-theme/src/types';

export const AutocompleteWrapperStyles = styled.div(
  (props: ThemeProps<Theme>) => `
  width: 100%;
  display: flex;
`,
);

export const SearchInputStyles = styled.input(
  (props: ThemeProps<Theme>) => `
    // background-color: ${props.theme.colors.blue.deepBlue};
    background: none;
    border: 0;
    outline: 0;
    min-width: 14rem;
    padding: 0 0.9rem 0.4rem 0.9rem;
    font-size: ${props.theme.font.large.font16};
    color: white;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:focus{
      box-shadow: none;
      outline: none;
    }
`,
);

export const SearchLabelStyles = styled.label(
  (props: ThemeProps<Theme>) => `
  color: #0084ff;
  font-size: ${props.theme.font.base}
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.4rem 0.9rem 0.5rem 0.9rem;
  line-height: 1.2rem;
`,
);

export const FieldWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  background-color: rgba(255,255,255, 0.1);
  border-radius: ${props.theme.misc.borderRadius.base};
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
`,
);
